import { SearchOption, TypeaheadInput, TypeaheadInputComponent } from "@jsq/ds/core";
import { withClientContext } from "~/apollo/client";
import { useGetArenasWithSearchLazyQuery } from "~/graphql/mainHooks";

interface Props {
  name?: string;
  label?: string;
  readOnly?: boolean;
  placeholder?: string;
  initialSearchValue?: string;
  onSelectOption?: (selectedOption: SearchOption) => void;
  onClearValue?: () => void;
  arenaTypeaheadInputRef?: React.RefObject<TypeaheadInputComponent>;
  /** Override the input's max width (defaults to 225px). */
  maxWidth?: string;
}

const ArenaSelector = (props: Props) => {
  /**
   * This represents the queries to get the list of arenas. Always ignore the admin arena.
   * The search term will be updated by the Typeahead code.
   */
  const [getArenasWithSearch, { loading, error, data }] = useGetArenasWithSearchLazyQuery({
    variables: {
      includeAdminArena: false,
      searchTerm: "",
    },
    fetchPolicy: "no-cache",
    context: withClientContext("staff"),
  });

  /**
   * This is where the list is populated from. It's populated from the above query.
   * Importantly the label shown here is the name of the arena and what will be visible to
   * the user. The ID is a global ID of the associated arena and can be used by callers.
   */
  const arenaOptions: SearchOption[] =
    data?.arenas?.edges?.map((obj) => ({
      id: obj?.node?.id,
      label: obj?.node?.name,
      type: "arena",
    })) ?? [];

  return (
    <TypeaheadInput
      css={{ maxWidth: props.maxWidth ?? "225px" }}
      name={props.name}
      label={props.label}
      readOnly={props.readOnly}
      placeholder={props.placeholder}
      initialSearchValue={props.initialSearchValue}
      className="stacked-md"
      options={arenaOptions}
      isLoading={loading}
      isError={error !== undefined}
      onDebouncedSearch={(searchTerm: string) => {
        void getArenasWithSearch({
          variables: {
            searchTerm: searchTerm.trim(),
          },
        });
      }}
      onSelectOption={props.onSelectOption}
      onClearValue={props.onClearValue}
      ref={props.arenaTypeaheadInputRef}
    ></TypeaheadInput>
  );
};
export default ArenaSelector;
